export class DefinitionOfDone {

  public id: number;
  public project_id: number;
  public name: string;
  public active: boolean;
  public isDeleted: boolean;


  public constructor(id: number, project_id: number, name: string, active: boolean, isDeleted = false) {
    this.id = id;
    this.project_id = project_id;
    this.name = name;
    this.active = active;
    this.isDeleted = isDeleted;
  }
}
